const tenkenTheme = {
  button: {
    color: {
      default: "bg-[#EEEEEE] hover:bg-[#E0E0E0] border border-[#BDBDBD]",
      primary:
        "bg-[#3B82F6] hover:bg-[#2563EB] border border-[#2563EB] text-[#F9FAFB]",
      purple:
        "bg-[#5E73C0] hover:bg-[#3A5CD8] border border-[#5E73C0] text-[#F9FAFB]",
      delete: "bg-[#fa5252] hover:bg-[#F24539] text-white",
      yellow:
        "bg-[#FACC15] hover:bg-[#EAB308] border border-[#EAB308] text-[#111827]",
      red: "bg-[#EF4444] hover:bg-[#DC2626] border border-[#DC2626] text-[#F9FAFB]",
      gray: "bg-[#D2D5DA] hover:bg-[#9CA3AF] border border-[#9CA3AF] text-[#111827]",
      dark: "bg-gray-400 hover:bg-gray-500 border border-gray-500 hover:border-gray-600 text-white",
      success:
        "bg-[#22C55E] hover:bg-[#16A34A] border border-[#16A34A] text-white",
      light:
        "bg-[#F9FAFB] hover:bg-[#E5E7EB] border border-[#9CA3AF] text-[#111827]",
      sidebar:
        "bg-[#FFFFFF] hover:bg-[#E0E0E0] border border-[#E0E0E0] text-[#111827]",
      reset: "bg-[#E0E0E0] hover:bg-tenken-gray-400 border border-[#9E9E9E]",
      primary_outline:
        "bg-white hover:bg-[#f6faff] border border-tenken-border-button-primary text-tenken-primary",
      white_outline:
        "bg-tenken-gray-100 hover:bg-tenken-gray-200 border border-tenken-gray-400 text-tenken-gray-900",
    },
    size: {
      xs: "text-[15px] font-normal",
      sm: "text-[15px] font-normal",
      md: "text-[15px] font-normal",
      lg: "text-base font-normal",
      xl: "text-base font-normal",
    },
  },
  card: {
    root: {
      base: "flex rounded-lg border border-gray-200 bg-white dark:border-gray-700 dark:bg-gray-800",
      children: "flex h-full flex-col justify-center gap-4 p-4",
    },
  },
  table: {
    root: {
      base: "w-full text-left lg:text-base text-[15px] text-tenken-gray-900",
      wrapper: "",
    },
    body: {
      base: "group/body",
      cell: {
        base: "lg:text-base text-[15px] lg:px-4 lg:py-4 px-3 py-3 group-first/body:group-first/row:first:rounded-tl-lg group-first/body:group-first/row:last:rounded-tr-lg group-last/body:group-last/row:first:rounded-bl-lg group-last/body:group-last/row:last:rounded-br-lg",
      },
    },
    head: {
      base: "group/head lg:text-base text-[15px] text-tenken-gray-900",
      cell: {
        base: "bg-gray-50 lg:px-4 lg:py-3 px-3 py-2.5 group-first/head:first:rounded-tl-lg group-first/head:last:rounded-tr-lg",
      },
    },
  },
  tabs: {
    tablist: {
      base: "flex text-center",
      styles: {
        pills:
          "border-b border-tenken-gray-500 space-x-0 flex-wrap text-sm font-medium text-gray-400",
      },
      tabitem: {
        styles: {
          underline: {
            base: "px-[28px] text-[16px]",
            active: {
              on: "border-b-2 border-blue-600 focus:ring-0",
              off: "border-transparent focus:ring-0",
            },
          },
          pills: {
            base: "lg:text-base text-[15px] text-black flex items-center justify-center py-2 px-8 rounded-none font-normal ml-0 disabled:cursor-not-allowed disabled:text-gray-400 disabled:dark:text-gray-500 focus:ring-0 focus:outline-none",
            active: {
              on: "border-b-2 border-r border-b-blue-600 border-r-tenken-gray-400 focus:ring-0 bg-[#2e90fa] text-white",
              off: "border-r focus:ring-0 bg-tenken-gray-300 border-tenken-gray-400",
            },
          },
        },
      },
    },
  },
  setting_tabs: {
    base: "flex flex-col gap-0 w-full gap-[20px]",
    tablist: {
      tabitem: {
        base: "flex items-center justify-center p-2 text-sm font-medium first:ml-0 focus:outline-none w-[140px] whitespace-nowrap",
        styles: {
          underline: {
            base: "rounded-0",
            active: {
              on: "w-[128px] lg:w-[140px] active border-b-2 border-b-[#2E90FA] bg-[#3B82F6] text-white font-normal",
              off: "w-[128px] lg:w-140px] border-b-2 border-x border-b-transparent border-x-[#BDBDBD] bg-[#E0E0E0] hover:border-b-gray-300 hover:text-gray-600",
            },
          },
        },
      },
    },
    tabpanel: "py-0",
  },
  modal_inspection_tabs: {
    base: "flex flex-col gap-0 w-full gap-[20px]",
    tablist: {
      tabitem: {
        base: "flex items-center justify-center p-2 text-sm font-medium first:ml-0 focus:outline-none w-[140px] whitespace-nowrap",
        styles: {
          underline: {
            base: "rounded-0",
            active: {
              on: "active border-b-2 border-b-[#2E90FA] bg-[#3B82F6] text-white font-normal",
              off: "border-b-2 border-x border-b-transparent border-x-[#BDBDBD] bg-[#E0E0E0] hover:border-b-gray-300 hover:text-gray-600",
            },
          },
        },
      },
    },
    tabpanel: "py-0",
  },
  treatment_tabs: {
    base: "flex flex-col gap-0 w-full gap-[20px]",
    tablist: {
      tabitem: {
        base: "flex items-center justify-center py-2 px-8 text-sm font-medium first:ml-0 focus:outline-none w-[140px]",
        styles: {
          underline: {
            base: "rounded-0",
            active: {
              on: "active border-b-2 border-b-[#2E90FA] bg-[#DCE8FF]",
              off: "border-b-2 border-x border-b-transparent border-x-[#BDBDBD] bg-[#E0E0E0] hover:border-b-gray-300 hover:text-gray-600",
            },
          },
        },
      },
    },
    tabpanel: "py-0 focus:outline-none",
  },
  search_tabs: {
    base: "flex flex-col gap-0",
    tablist: {
      tabitem: {
        base: "flex items-center justify-center py-2 px-8 text-sm font-medium first:ml-0 focus:outline-none",
        styles: {
          underline: {
            base: "rounded-0",
            active: {
              on: "active border-b-2 border-b-[#2E90FA] bg-[#DCE8FF]",
              off: "border-b-2 border-x border-b-transparent border-x-[#BDBDBD] bg-[#E0E0E0] hover:border-b-gray-300 hover:text-gray-600",
            },
          },
        },
      },
    },
    tabpanel: "py-0 focus:outline-none",
  },
  machine_input_tabs: {
    base: "flex flex-col gap-2",
    tablist: {
      base: "flex text-center",
      styles: {
        pills:
          "border-b border-tenken-gray-500 space-x-0 flex-wrap text-sm font-medium text-gray-400 focus-visible:outline-none",
      },
      tabitem: {
        styles: {
          underline: {
            base: "px-[28px] text-[16px]",
            active: {
              on: "border-b-2 border-blue-600 focus:ring-0",
              off: "border-transparent focus:ring-0",
            },
          },
          pills: {
            base: "xl:text-[16px] text-[15px] text-black flex items-center justify-center py-2 px-8 rounded-none font-normal ml-0 disabled:cursor-not-allowed disabled:text-gray-400 disabled:dark:text-gray-500 focus:ring-0 focus:outline-none",
            active: {
              on: "border-b-2 border-r border-b-blue-600 border-r-tenken-gray-400 focus:ring-0 bg-[#2e90fa] text-white",
              off: "border-r focus:ring-0 bg-tenken-gray-300 border-tenken-gray-400",
            },
          },
        },
      },
    },
    tabpanel: "py-3 focus:outline-none",
  },
  search_result_tabs: {
    base: "flex flex-col gap-0 w-fit pr-[24px]",
    tablist: {
      tabitem: {
        base: "flex items-center justify-center py-2 px-8 text-sm font-medium first:ml-0 focus:outline-none",
        styles: {
          underline: {
            base: "rounded-0",
            active: {
              on: "active border-b-2 border-b-[#2E90FA] bg-[#3B82F6] text-white",
              off: "border-b-2 border-x border-b-transparent border-x-[#BDBDBD] bg-[#E0E0E0] hover:border-b-gray-300 hover:text-gray-600",
            },
          },
        },
      },
    },
    tabpanel: "py-0",
  },
  toggle: {
    checked: {
      off: "border-gray-200 bg-[#BDBDBD]",
      color: {
        primary: "bg-[#2e90fa] border-[#1a90Fa]",
      },
    },
    sizes: {
      sm: "h-5 w-9 min-w-9 after:h-4 after:w-4",
      md: "h-5 w-9 min-w-9 after:h-4 after:w-4",
      lg: "h-6 w-11 min-w-11 after:h-5 after:w-5",
    },
  },
  modal: {
    header: {
      base: "flex items-start justify-between rounded-b-none rounded-t-[6px] border-b px-[16px] py-[12px]",
      title: "text-lg font-bold",
    },
    body: {
      base: "flex-1 overflow-auto p-[16px]",
      popup: "pt-0",
    },
    footer: {
      base: "flex items-center p-[16px] rounded-t-none rounded-b-[6px] border-gray-200",
    },
  },
  modal_help: {
    header: {
      base: "flex items-start justify-between rounded-t-lg border-b px-5 py-4 bg-[#2E90FA52]",
      title: "text-lg font-medium",
      close: {
        base: "ml-auto inline-flex items-center rounded-lg bg-transparent p-1.5 text-sm text-[#667085] hover:bg-[#2E90FA20] hover:text-blue-500",
      },
    },
    footer: {
      base: "flex items-center rounded-b-lg border-gray-200 py-4 px-6 justify-end",
    },
  },
  radio: {
    root: {
      base: "h-6 w-6 border-2 border-[#BDBDBD] text-white checked:border-[#3B82Fe] disabled:bg-gray-200",
    },
  },
  small_radio: {
    root: {
      base: "h-5 w-5 border-2 border-[#BDBDBD] text-white checked:border-[#3B82Fe]",
    },
  },
  tooltip: {
    content: "relative z-20 break-words max-w-[400px] whitespace-normal"
  }
};

export default tenkenTheme;
